import { OpenInNew, Edit, Visibility, Comment } from "@material-ui/icons";
import React from "react";
import "./ShortlistStory.scss";
import moment from "moment/moment";
import { RouteComponentProps, withRouter } from "react-router";
import black from "../../icons/default2.png";
import ReactGA from "react-ga";
import config from "../../config/apiConfig";

export type Publish = {
    id: string;
    avatar: string;
    title: string;
    updatedAt: Date;
    comments: number;
    views: number;
};

export function mapToPublish(data: { [key: string]: any }): Publish {
    return {
        id: data.storyId,
        avatar: !!data.imageUrl
            ? "https://apis.serendipitymedia.tech/assets/" + data.imageUrl
            : "",
        title: data.title,
        updatedAt: new Date(),
        comments: data.totalComments,
        views: data.totalClick,
    };
}

const Selected: React.FC<{ published: Publish[] } & RouteComponentProps> = ({
    published,
    history,
}) => {
    return (
        <React.Fragment>
            {published.map((draft, index) => (
                <div className="draft">
                    <div className="image">
                        <img
                            src={
                                draft.avatar.trim() !== ""
                                    ? draft.avatar
                                    : black
                            }
                        />
                    </div>
                    <div className="content">
                        <h5>
                            {draft.title.length > 80
                                ? draft.title.substr(0, 80) + "..."
                                : draft.title}
                        </h5>
                        <p>
                            Published on{" "}
                            {moment(draft.updatedAt).format(
                                "Do MMMM YYYY [at] h:mm a"
                            )}
                        </p>
                        <div className="flex space-between">
                            <div className="concat-buttons">
                                <button style={{ width: "auto" }}>
                                    Remove from selected
                                </button>
                                <button
                                    style={{
                                        background: config.primary_color,
                                        color: "#ffffff",
                                        width: "auto"
                                    }}
                                >
                                    Schedule a call
                                </button>
                            </div>

                            <div>
                                <Visibility />
                                {draft.views}
                                <Comment />
                                {draft.comments}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

export default withRouter(Selected);
